import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-coverage-info',
  templateUrl: './coverage-info.component.html',
  styleUrls: ['./coverage-info.component.scss'],
})
export class CoverageInfoComponent {
  
  @Input() title: string;
  @Input() price: string | number;

  constructor(){} 
}
